export const key = 'MINERIUM_';

const safeLocalStorage = () => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return null;
  }

  return window.localStorage;
};

const resolveCookieDomain = () => {
  if (typeof window === 'undefined') {
    return '';
  }

  const hostname = window.location.hostname;
  if (
    !hostname ||
    hostname === 'localhost' ||
    hostname.includes(':') ||
    /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname)
  ) {
    return '';
  }

  return `;domain=${hostname}`;
};

export const getStoredValue = key => {
  const storage = safeLocalStorage();
  if (storage) {
    const stored = storage.getItem(key);
    if (stored !== null) {
      return stored;
    }
  }

  if (typeof document === 'undefined') {
    return null;
  }

  const cookie = document.cookie
    .split('; ')
    .find(row => row.startsWith(`${key}=`));

  if (!cookie) {
    return null;
  }

  return decodeURIComponent(cookie.split('=').slice(1).join('='));
};

export const storeValue = (key, value, expireDays = 3650) => {
  const normalizedValue = String(value);
  const storage = safeLocalStorage();
  if (storage) {
    storage.setItem(key, normalizedValue);
  }

  if (typeof document === 'undefined') {
    return;
  }

  const secure = typeof window !== 'undefined' && window.location.protocol === 'https:'
    ? ';Secure'
    : '';

  document.cookie = `${key}=${encodeURIComponent(normalizedValue)}${resolveCookieDomain()};path=/;SameSite=Lax${secure};expires=${new Date(
    Date.now() + 1000 * 60 * 60 * 24 * expireDays,
  ).toGMTString()}`;
};
